import { BaseEntity } from '@/api/EntityApi';
import { DeepKeys } from '@tanstack/react-table';
import { Asset } from '@/api/AssetApi';
import { AttributeValue } from '@/api/AttributeValueApi';
import LANGUAGES from '@/configs/languages';

export type Language = keyof typeof LANGUAGES;
export type ForeignLanguage = Exclude<Language, 'PL'>;
export type Translations<TData> = Record<ForeignLanguage, TData>;

export type SortOrder = 'ASC' | 'DESC';

export interface Sort<TData extends BaseEntity = any> {
	key: DeepKeys<TData> | null;
	order: SortOrder;
}

export interface ApiQueryOptions<TData extends BaseEntity> {
	page: number;
	limit: number;
	search: string;
	sortBy: Sort<TData>;
}

export type CustomFilters = Record<string, unknown>;

export interface ApiPaginatedResponse<TData extends {} = {}> {
	data: TData[];
	meta: {
		currentPage: number;
		itemsPerPage: number;
		totalItems: number;
		totalPages: number;
	};
}

export interface ApiFormattedResponseData<TData extends {} = {}> {
	data: TData[];
	totalPages: number;
}

export interface CreateManyResponse {
	passed: string[];
	rejected: string[];
}

export interface Attachment {
	id: UUID;
	path: string;
	name: string;
	size: number;
	mimetype: string;
}

export type UUID = ReturnType<typeof crypto.randomUUID>;

export enum CreatorActionType {
	SET_MATERIAL = 'SET_MATERIAL',
	SET_MODEL = 'SET_MODEL',
	CAMERA_FOCUS = 'CAMERA_FOCUS',
	UPDATE_MATERIAL = 'UPDATE_MATERIAL',
}

export type CreatorAction = {
	id: UUID;
	attributeValue: AttributeValue;
	type: CreatorActionType;
	payload: CreatorActionPayload;
};

export type CreatorActionPayload = {
	asset?: Asset;
	target?: string;
};
